import gql from 'graphql-tag';

/**
 * GQL Update Preventive Maintenance Task Mutation
 */

export const updatePMTaskStatusMutation = gql`
  mutation updatePMTaskStatusMutation($task: UpdateTaskStatus!) {
    updateTaskStatus(task: $task) {
      id
      updatedAt
    }
  }
`;
